import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ButtonProps as AntdButtonProps } from 'antd/lib/button/button';
import { PercentageOutlined } from '@ant-design/icons';
import { Button } from '~/components';
import { useMutateSharesPercentage } from '~/controllers/sharePercantage';

interface RefreshSharesButtonType extends AntdButtonProps {
  form: any;
  setLoading: any;
  shareholderType: 'INDIVIDUAL' | 'BUSINESSES' | 'BENEFICIAL_OWNER';
  n: any;
}

const RefreshSharesButton: FC<RefreshSharesButtonType> = (props) => {
  const { form, setLoading, shareholderType, n } = props;
  const { t } = useTranslation();
  const phoneNumber = form.getFieldValue(n(['data', 'phoneNo'])) || form.getFieldValue(n(['data', 'mobileNo']));
  const getSharesPercentage = useMutateSharesPercentage();
  const sharesPath = n(['shares']);

  const handleSharesButton = () => {
    setLoading(true);
    getSharesPercentage
      .mutateAsync({
        phoneNumber,
        shareholderType,
      })
      .then((data) => {
        const { shares } = data;
        form.setFieldValue(sharesPath, shares);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  return (
    <Button
      id="mutateSharesPercentage"
      size="large"
      icon={<PercentageOutlined />}
      onClick={handleSharesButton}
      {...props}
    >
      {t('Refresh Shares')}
    </Button>
  );
};

export default RefreshSharesButton;
